import React from "react";
import Team from "../components/Team/Team";
import "./AboutUsStyle.css";

function AboutUs() {
  return (
    <div className="about-container">
      <section className="about-section">
        <h1>Who we are</h1>
        <p>
          IndoDefTech is a forward-thinking technology company that focuses on digital transformation, automation, 
          and AI-driven innovations. We are committed to empowering enterprises, governments, and startups 
          through scalable digital platforms and intelligent systems.
        </p>

        <p>
          We create impactful technology solutions that drive growth, enhance security, 
          and promote sustainable digital ecosystems across industries.
        </p>

      </section>

      <section className="about-section">
        <h2>Our Core Values</h2>
        <ul>
          <li>Innovation that transforms.</li>
          <li>Integrity in every interaction.</li>
          <li>Commitment to excellence and scalability.</li>
          <li>Collaboration and continuous learning.</li>
        </ul> 
      </section>


      <section className="about-section">
        <Team />
      </section>

    </div>
  );
}

export default AboutUs;